import { Component, EventEmitter, Input, Output } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'mg-checkbox-element',
  templateUrl: './checkbox-element.component.html',
  styleUrls: ['./checkbox-element.component.scss'],
  standalone: false
})
export class CheckboxElementComponent {
  @Input() value: boolean
  @Input() extraClass = ''
  @Input() labelClass = ''
  @Input() label = ''
  @Input() disabled = false
  @Input() disableColorChange = true

  @Output() changed = new EventEmitter<boolean>()
}
